var _defs, _rect, _rect2, _circle, _circle2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: "15%",
    y1: "0%",
    x2: "85%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7A8B6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4A5C45"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 22,
    fill: "url(#g2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 22,
    fill: "none",
    stroke: "rgba(255,255,255,0.13)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 34,
    r: 14,
    fill: "none",
    stroke: "rgba(255,255,255,0.92)",
    strokeWidth: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 34,
    r: 3.8,
    fill: "rgba(255,255,255,0.92)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 47,
    width: 5,
    height: 25,
    rx: 2.5,
    fill: "rgba(255,255,255,0.92)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 57.5,
    width: 9,
    height: 3.5,
    rx: 1.75,
    fill: "rgba(255,255,255,0.92)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 65,
    width: 7,
    height: 3.5,
    rx: 1.75,
    fill: "rgba(255,255,255,0.92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8fb6e52f5ffa021af1d189a919a52aa4.svg";
export { ForwardRef as ReactComponent };